
const defaultConfig = {
	"THEME": "negishi",
	"THEMES": ["negishi", "nooch", "butcher", "missmiu", "kitchenrepublic"],
	"LOGIN_COOKIE": "utoken",
	"ACCUMULATOR": true,
	"ACCUMULATOR_COOKIE": "fwgcontaoaccumulator",
	"FEATURE_ADDITIONALPRODUCTS": true,
	"FEATURE_CHILDPRODUCTS": true,
	"FEATURE_LIMITEDSTOCK": true,
	"FEATURE_RESERVATION": true,
	"FEATURE_ORDERBOX_LOGIN": false,
	"FEATURE_ORDERBOX_DELIVERY": true,
	"FEATURE_ORDERBOX_TAKEAWAY": true,
	"FEATURE_ORDERBOX_REGIONS": false,
	"FEATURE_ORDERBOX_GEOLOCATION": false,
	"FEATURE_REFERRAL": true,
	"FEATURE_NEWSLETTER_REGISTRATION": true,
	"FEATURE_NEWSLETTER_CHECKOUT": true,
	"FEATURE_CO2_OPTOUT": false,
	"FEATURE_CO2_OPTOUT_PHASE2": false,
	"FEATURE_REUSABLE_DISHES": true,
	"FEATURE_NUTRITION_DETAILS": false,
	"FEATURE_CART_ITEM_NOTES": false,
	"FEATURE_GROUP_ORDERS": true,
	"FEATURE_ORDER_NPS": false,
	"FEATURE_TIP_VARIANTS": true,
	"FEATURE_PRODUCT_CO2_REMOVAL": false,
  "FEATURE_LIVE_ORDER_STATE": true,
  "FEATURE_POINZ": false,
  "FEATURE_POINZ_REGISTER": false,
	"BRAND": "negishi",
	"LANGUAGE": "de",
	"LOCALE": "de_CH",
	"LOCAL_TIME": "",
	"LOCALE_DATE_FORMAT": "",
	"COUNTRY": "CH",
	"NOTIFY_MESSAGE": "",
	"NOTIFY_MESSAGE_TYPE": "",
	"DELIVERY_TIME": 15,
	"CONTAO_ENDPOINT": "",
	"SHOPMANAGER_ENDPOINT": "https://stage.shopmanager.fwg-management.ch",
	"DATATRANS_SCRIPT": "https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js",
	"CART_COOKIE": "fwgbasket",
	"GROUP_ORDER_PARTICIPANT_COOKIE": "fwggroupparticipant",
	"GROUP_ORDER_PARTICIPANT_HEADER": "X-AUTH-GROUP-TOKEN",
	"CHECKOUT_MERCHANT_ID": "1100004624",
	"SHOP_URL": "/de/shop",
	"HOME_URL": "/de/home",
	"CHECKOUT_OFFLINEPAYMENT_IDS": ['cash', 'invoice'],
	"CHECKOUT_INVOICEADDRESS_ALLOWED_IDS": ['invoice'],
	"CHECKOUT_TIP_EXCLUDE_IDS": ['cash'],
	"CHECKOUT_URL": "/de/checkout",
	"CHECKOUT_SUCCESS_URL": "/de/checkout#success",
	"CHECKOUT_CANCEL_URL": "/de/checkout#cancel",
	"CHECKOUT_ERROR_URL": "/de/checkout#error",
	"CHECKOUT_COMPLETE_URL": "/de/checkout#complete",
	"LOGOUT_CONFIRM_URL": "/de/checkout#complete",
	"PASSWORD_RESET_URL": "",
	"REGISTER_CONFIRM_URL": "",
	"ACCOUNT_QR_PREFIX": "ACC.",
	"messages": [],
	"DEFAULT_CHANNEL": "kitchenrepublic_zurich_west",
	"MENU_SHIPPING_CODE": "inhouse",
	"ADDITIONALPRODUCTS_TAXONS": [
		'negishi',
		'nooch',
		'missmiu',
	],
	"NPS_SURVEY_URL": null,
	"TIP_SURVEY_URL": "https://ww3.unipark.de/uc/IMM_MA/bfb1/?a={tokenValue}&b={tipMainVariant}-{tipSubVariant}",
  "LIVE_ORDER_STATES": [10, 60, 70, 110],

	"DEBUG": false,
	"DEBUG_COOKIE": "fwgcontaodebug",

	// MOCK SECTION
	"MOCK": false,
	"MOCK_COOKIE": "fwgcontaomock",
	"MOCK_PRODUCT_IMAGE": "",
	"MOCK_CHECKOUT_PREFILL": true,
	"MOCK_CART_HASALCOHOL": true,
	"MOCK_LOGIN": true,
	"MOCK_LOGIN_COOKIE": "fwgcontaologin",
	"MOCK_ACCOUNT_HAS_ADDRESS": false,
	"MOCK_CARTOPEN_FAILONCE": false,
	"MOCK_SHOPLIST_LIMITSTOCK": false,
	"MOCK_CART_HASTIP": true,
	"MOCK_ORDERS_URL": "/files/mockdata/response/GET_orders.json",
	"MOCK_PRODUCTS_URL": "/files/mockdata/response/GET_products_by_slug.json",
	"MOCK_PRODUCT_TAGS_URL": "/files/mockdata/response/GET_product_tags.json",
	"MOCK_CART_CREATE_URL": "/files/mockdata/response/POST_carts.json",
	"MOCK_CART_GET_URL": "/files/mockdata/response/POST_carts_multiple-items.json",
	"MOCK_CART_SUB_GET_URL": "/files/mockdata/response/GET_cart_sub.json",
	"MOCK_ORDER_SUB_GET_URL": "/files/mockdata/response/GET_order_sub.json",
	"MOCK_CATEGORIES_URL": "/files/mockdata/response/GET_taxons.json",
	"MOCK_CHECKOUT_URL": '/files/mockdata/response/GET_checkout.json',
	"MOCK_CHECKOUT_PAYMENT_URL": "/files/mockdata/response/GET_checkout_payment.json",
	"MOCK_CHECKOUT_SHIPPING_URL": "/files/mockdata/response/GET_checkout_shipping.json",
	"MOCK_ORDER_URL": "/files/mockdata/response/GET_order.json",
	"MOCK_ZIP_URL": "/files/mockdata/response/GET_zips.json",
	"MOCK_ACCOUNT_ME_URL": "/files/mockdata/response/GET_me.json",
	"MOCK_ACCOUNT_PRODUCTS_URL": "/files/mockdata/response/GET_products_by_slug.json",
	"MOCK_ACCOUNT_ADDRESSES_URL": "/files/mockdata/response/GET_address-book.json",
	"MOCK_LOCATIONRESERVATION_URL": "/files/mockdata/response/GET_reservation.json",
	"MOCK_CHANNELS_URL": "/files/mockdata/response/GET_channels.json",
	"MOCK_MIGRATE_BRANDS_URL": "/files/mockdata/response/POST_migrate-brands.json",
	"MOCK_RESERVATION_LIST_URL": "/files/mockdata/response/GET_reservation_list.json",
	"MOCK_RESERVATION_RESTAURANTS_URL": "/files/mockdata/response/GET_reservation_restaurants.json",
	"MOCK_RESERVATION_AVAILABILITIES_URL": "/files/mockdata/response/GET_reservation_availabilities.json",
	"MOCK_RESERVATION_CREATE_URL": "/files/mockdata/response/POST_reservation_create.json",
	"MOCK_RESERVATION_CALENDAR_URL": "/files/mockdata/response/GET_reservation_calendar.ics",

	// LANG STRINGS
	"LANG_ORDER_BOX_TITLE": null,

	// THEME VALUES
	"THEME_ORDER_BOX_LINK": null,
	"THEME_PAYMENT_TIMEOUT": 60 * 1000,
	"THEME_ORDER_STATE_INTERVAL": 30 * 1000,
}

let themeConfig = {}
let overrideConfig = {}
let componentOptions = {}

function readFromCookie(config) {
	let cfg = {}
	cfg.DEBUG = window.localStorage.getItem(config.DEBUG_COOKIE) == "true"
	cfg.MOCK = window.localStorage.getItem(config.MOCK_COOKIE) == "true"
	cfg.MOCK_CHECKOUT_PREFILL = window.localStorage.getItem(config.MOCK_COOKIE + "checkoutprefill") == "true"
	cfg.MOCK_ACCOUNT_HAS_ADDRESS = window.localStorage.getItem(config.MOCK_COOKIE + "accountaddress") == "true"
	cfg.MOCK_SHOPLIST_LIMITSTOCK = window.localStorage.getItem(config.MOCK_COOKIE + "limitstock") == "true"
	var accumulatorConfig = window.localStorage.getItem(config.ACCUMULATOR_COOKIE)
	cfg.MOCK_LOGIN = window.localStorage.getItem(config.MOCK_LOGIN_COOKIE) == "true"
	cfg.MOCK_CARTOPEN_FAILONCE = window.localStorage.getItem(config.MOCK_COOKIE + "cartopenfailonce") == "true"
	if(typeof accumulatorConfig === 'string'){
		cfg.ACCUMULATOR = window.localStorage.getItem(config.ACCUMULATOR_COOKIE) == "true"
	}
	return cfg
}
export function readFromComponentOptions(opts) {
	for (var i in opts) {
		if (defaultConfig.hasOwnProperty(i)) {
			componentOptions[i] = opts[i]
		}
	}
	updateConfig()
}
export function readFromHtmlJson() {
	let cfg = {}
	const el = document.querySelector("#baseconfig")
	if (el && el.getAttribute("type") == "application/json") {
		let data = JSON.parse(el.innerHTML.replace(/^\s+/, ""))
		Object.assign(cfg, data)
	}
	return cfg
}

export function setConfigValue(key, value) {
	overrideConfig[key] = value
	updateConfig()
}
export function setThemeConfig(config) {
	themeConfig = config
	updateConfig()
}

export function updateConfig() {
	let config = cfg || defaultConfig
	Object.assign(config, overrideConfig)
	Object.assign(config, themeConfig)
	Object.assign(config, readFromHtmlJson(config))
	Object.assign(config, readFromCookie(config))
	//Object.assign(config, readFromUrl(config))
	//Object.assign(config, readFromDev(config))
	//Object.assign(config, readFromHtml(config))
	//Object.assign(config, readFromRemote(config))
	//Object.assign(config, readFromUrl(config))
	Object.assign(config, overrideConfig)
	return config
}


var cfg = updateConfig()

//DEBUG: expose config
window.fwgcontao_config = cfg
export const config = cfg

export const vueConfig = {
	registerGlobalsComponentMap: {}
}
//export default config
